import { Component, OnInit } from '@angular/core';
import { BasePagedPage } from '../../base-paged-page';
import { StoreModel } from 'src/app/models/store/store.model';
import { ApiService } from 'src/app/services/api.service';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-stores',
    templateUrl: './stores.component.html',
    styleUrls: ['./stores.component.scss'],
    standalone: false
})
export class StoresComponent extends BasePagedPage<string, StoreModel> implements OnInit {

  constructor(private mApiService: ApiService, private mRouter: Router) {
    super();
  }

  public override getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<StoreModel>>('/api/admin/store/list', {
      page: page ?? 1,
      pageSize: this.pageSize,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  ngOnInit(): void {
    this.getData(1);
  }

  public addNew() {
    this.mRouter.navigate(['/stores/list/edit/new']);
  }

  public deleteItem(id: string) {
    if (!confirm('Удалить этот магазин?')) {
      return;
    }

    this.isBusy = true;

    this.mApiService.delete('/api/admin/store/' + id).subscribe({
      next: () => {
        this.getData(this.page);
      }, error: () => this.isBusy = false
    });
  }

}
